const reversePhoneLookupFreeVsPaid = {
  slug: 'reverse-phone-lookup-free-vs-paid',
  title: 'Reverse phone lookup: free vs paid',
  description:
    'Compare free and paid reverse phone lookup services — what you get, accuracy limits, and how community sites like WhoDatNumber fit in.',
  category: 'guides',
  guideType: 'comparison',
  readMinutes: 4,
  partnerTip: 'none',
  relatedSlugs: ['trace-unknown-phone-number', 'understanding-caller-id-australia'],
  sections: [
    {
      type: 'paragraph',
      text: 'Reverse lookup means entering a phone number to find reports, names, or business details. Free and paid tools differ in data sources and reliability.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Free options',
    },
    {
      type: 'list',
      items: [
        'Community report sites (e.g. WhoDatNumber) — scam/spam experiences from real users',
        'Search engines — may surface business pages or forum warnings',
        'Carrier apps — sometimes label known spam for mobile subscribers',
      ],
    },
    {
      type: 'tip',
      text: 'WhoDatNumber is free, ad-supported, and focused on moderated community reports rather than selling personal data.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Paid options',
    },
    {
      type: 'list',
      items: [
        'People-search databases aggregating public records',
        'Premium caller-ID services with larger name databases',
        'Often charge per lookup or monthly subscription',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Limitations to expect',
    },
    {
      type: 'list',
      items: [
        'Mobile and VoIP numbers may have little public data',
        'Spoofed numbers point to the wrong person or business',
        'Outdated records after number reassignment',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Which is best for you?',
    },
    {
      type: 'paragraph',
      text: 'Start free: search the number here, read reports, and verify through official channels. Pay only if you need deeper public-records research and understand the privacy trade-offs.',
    },
    {
      type: 'lookupCta',
    },
  ],
};

export default reversePhoneLookupFreeVsPaid;

